import { useEffect, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import { useCheckLastPreferenceRedirect } from "hooks/preferences"
import HomeLayout from "modules/home-layout"
import { SUPPORT_EMAIL } from "helpers/constants"
import particlesConfig from "../../../pages/particlesConfig.json"
import "./style.scss"

export default function NotFoundPage({ layoutDeactivated }) {
  const { wasRedirectedFromPreferences, deletePreferenceAndRedirectToDefault } = useCheckLastPreferenceRedirect()

  useEffect(() => {
    window.particlesJS("particles-js", particlesConfig)
  }, [])

  useLayoutEffect(() => {
    if (wasRedirectedFromPreferences) {
      deletePreferenceAndRedirectToDefault()
    }
  }, [wasRedirectedFromPreferences, deletePreferenceAndRedirectToDefault])

  const result = <div className="components_404">
    <div>
      <h1>Aargh!</h1>
      <h2>Sorry for the inconvenience &hellip;</h2>
      <p className="error-code">Error code: 404</p>
      <p>We could not find what you were looking for.</p>
      <p>If you need immediate assistance, please use the help widget at the bottom-right or send an email to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> to get in touch with us.</p>
    </div>
    <div>
      <img src="https://s3.amazonaws.com/pi-ompnt-nodejs/penguin4.png" width="100%" />
    </div>
  </div>

  return <div className="components_404-wrapper">
    <div id="particles-js" />
    { layoutDeactivated ? result : <HomeLayout>{result}</HomeLayout> }
  </div>
}

NotFoundPage.propTypes = {
  layoutDeactivated: PropTypes.bool,
}
